import { UserOutlined } from '@ant-design/icons';
import { Descriptions, Tag } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import ReplaceStrings from '../../../../config/replaceStrings';
import Routes from '../../../../config/routes';
import { translations } from '../../../../config/translations';
import { Props } from './index';
import CertificateValidity from '../../certificate-validity/CertificateValidity';
import ToolMultimediaSection from './ToolMultimediaSection';

const ToolDetails: React.FC<Props> = ({ tool, canEditMultimedia, onToolUpdated }) => {
    return (
        <Descriptions bordered size="small" column={1}>
            <Descriptions.Item label={translations.tools.number}>{tool.number}</Descriptions.Item>
            <Descriptions.Item label={translations.projects.name}>
                {tool.name}
            </Descriptions.Item>
            <Descriptions.Item label={translations.projects.description}>
                {tool.description}
            </Descriptions.Item>
            <Descriptions.Item label={translations.tools.certificateValidUntil}>
                <CertificateValidity validUntil={tool.certificateValidUntil} />
            </Descriptions.Item>
            <Descriptions.Item label={translations.news.archived}>
                {tool.isArchived ? 'Da' : 'Ne'}
            </Descriptions.Item>
            {tool.isArchived && tool.archiveReason && (
                <Descriptions.Item label={translations.transfers.archiveReason}>
                    {tool.archiveReason}
                </Descriptions.Item>
            )}
            <Descriptions.Item label={translations.transfers.location}>
                {tool.currentEmployeeId != null ? (
                    <>
                        <UserOutlined style={{ marginRight: 6 }} />
                        {tool.currentEmployeeName}
                    </>
                ) : (
                    tool.currentWarehouseName
                )}
                {tool.activeTransferId != null && (
                    <Link
                        to={Routes.ROUTE_TRANSFERS_READ.replace(
                            ReplaceStrings.ENTITY_ID,
                            tool.activeTransferId.toString()
                        )}
                    >
                        <Tag color="blue" style={{ marginLeft: 8, cursor: 'pointer' }}>
                            {translations.transfers.inTransferTo} {tool.activeTransferToName}
                        </Tag>
                    </Link>
                )}
            </Descriptions.Item>
            <Descriptions.Item label={translations.tools.multimedia}>
                <ToolMultimediaSection
                    tool={tool}
                    canEdit={!!canEditMultimedia}
                    onToolUpdated={onToolUpdated}
                />
            </Descriptions.Item>
        </Descriptions>
    );
};

export default ToolDetails;

